import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import { isAuthenticatedSelector } from "../../../../redux/profile/authAndReg/selectors";
import { LoginIcon } from "../../../../components";
import { SubMenuAbout } from "../SubMenuAbout/SubMenuAbout";
import { MainMenuItemsType } from "../../types";
import styles from "./MainMenuList.module.scss";

interface MainMenuListProps {
  menuItems: MainMenuItemsType;
  isMobile: boolean;
  onItemClick?: () => void;
  isMenuOpen: boolean;
  onClose: () => void;
  menuRef: React.RefObject<HTMLElement>;
}

export const MainMenuList: React.FC<MainMenuListProps> = ({
  menuItems,
  isMobile,
  onItemClick,
  isMenuOpen,
  onClose,
  menuRef,
}) => {
  const auth = useSelector(isAuthenticatedSelector);
  const location = useLocation();

  const handleItemClick = (href: string) => {
    if (href === location.pathname && onItemClick) {
      onItemClick();
    }
  };

  const renderMenuItems = () => {
    return menuItems.map(({ id, name, href, subMenu }) => {
      if (subMenu) {
        if (isMobile) {
          return (
            <li key={id}>
              <Link
                onClick={() => {
                  if ("/about" === location.pathname && onItemClick) {
                    onItemClick();
                  }
                }}
                to="/about"
              >
                {name}
              </Link>
            </li>
          );
        } else {
          return (
            <li key={id}>
              <SubMenuAbout name={name} href={href} />
            </li>
          );
        }
      } else {
        return (
          <li key={id}>
            <Link onClick={() => handleItemClick(href)} to={href}>
              {name}
            </Link>
          </li>
        );
      }
    });
  };

  const renderMobileAuthItem = () => {
    if (!isMobile) return null;

    if (auth) {
      return (
        <li>
          <Link
            onClick={() => {
              if ("/profile" === location.pathname && onItemClick) {
                onItemClick();
              }
            }}
            to="/profile"
          >
            Профиль
          </Link>
        </li>
      );
    } else {
      return <LoginIcon isMobileMenu={true} />;
    }
  };

  return (
    <>
      {isMobile && isMenuOpen && (
        <div 
          className={styles.mainMenu__overlay}
          onClick={onClose}
          aria-label="Закрыть меню"
        />
      )}
      <nav
        className={`${styles.mainMenu} ${isMenuOpen ? styles.active : ""}`}
        ref={menuRef}
      >
        {isMobile && (
          <button
            className={styles.mainMenu__closeButton}
            onClick={onClose}
            aria-label="Закрыть меню"
          >
            <span></span>
            <span></span>
          </button>
        )}
        <ul className={styles.mainMenu__list}>
          {renderMenuItems()}
          {isMobile && (
            <>
              <li>
                <Link 
                  onClick={() => {
                    if ("/rules" === location.pathname && onItemClick) {
                      onItemClick();
                    }
                  }} 
                  to="/rules"
                >
                  Правила Клуба
                </Link>
              </li>
              <li>
                <Link 
                  onClick={() => {
                    if ("/politics" === location.pathname && onItemClick) {
                      onItemClick();
                    }
                  }} 
                  to="/politics"
                >
                  Политика конфиденциальности
                </Link>
              </li>
            </>
          )}
        </ul>
      </nav>
    </>
  );
};

